export const FILTER_TYPES = {
  ARRAY: "array",
  MANY_FIELDS: "many-fields",
  SINGLE_FIELD: "single-field",
  SOCIAL_USERNAME: "social-username",
};

export const CONTENT_KEYWORD_BLACKLIST = [
  "chosenKeywords",
  "searchHashtags",
  "searchMentions",
  "searchBioKeywords",
];

export const FILTER_FIELD_NAMES = {
  AUDIENCE_AGE: "audienceAge",
  SELECTED_AUDIENCE_COUNTRIES: "selectedAudienceCountries",
  SELECTED_AUDIENCE_LANGUAGES: "selectedAudienceLanguages",
  AUDIENCE_GENDER: "audienceGender",
  CHOSEN_BRANDS: "chosenBrands",
  CHOSEN_TOPICS: "chosenTopics",
  CHOSEN_INFLUENCER_IG_CATEGORIES: "chosenInfluencerIgCategories",
  CHOSEN_INFLUENCER_SNAPCHAT_CATEGORIES: "chosenInfluencerSnapchatCategories",
  CHOSEN_INFLUENCER_INTERESTS: "chosenInfluencerInterests",
  INFLUENCER_AGE: "influencerAge",
  SELECTED_INFLUENCER_COUNTRIES: "selectedInfluencerCountries",
  SELECTED_INFLUENCER_CITIES: "selectedInfluencerCities",
  INFLUENCER_FOLLOWERS: "influencerFollowers",
  SELECTED_PROVIDERS: "selectedProviders",
  INFLUENCER_SOCIAL_USERNAME: "influencerSocialUsername",
  INFLUENCER_SOCIAL_PROVIDER: "influencerSocialProvider",
  INFLUENCER_GENDER: "influencerGender",
  AUDIENCE_CREDIBILITY_SCORE: "audienceCredibilityScore",
  PAID_POST_PERFORMANCE_MIN: "paidPostPerformanceMin",
  MINIMUM_ER: "minimumEr",
  CHOSEN_KEYWORDS: "chosenKeywords",
  LAST_POSTS_WITHIN: "lastPostsWithin",
  SEARCH_CONTENTS: "searchContents",
  SEARCH_HASHTAGS: "searchHashtags",
  SEARCH_MENTIONS: "searchMentions",
  SEARCH_BIO_KEYWORDS: "searchBioKeywords",
  HAS_CONTACT_DATA: "hasContactData",
  EXCLUDE_CREATORS_FROM_LIST: "excludeCreatorsFromList",
  SHOW_ONLY_CREATORS_AVAILABLE_IN_CRM: "showOnlyCreatorsAvailableInCrm",
  CREATORS_AVAILABLE_IN_CRM: "creatorsAvailableInCrm",
  CHOSEN_UNIFIED_CATEGORIES: "chosenUnifiedCategories",
  CREATOR_TAGS: "selectedCreatorTags",
};

export const SEARCH_FILTER_CONFIGS = [
  {
    name: FILTER_FIELD_NAMES.AUDIENCE_AGE,
    id: "front_audience_age",
    defaultMessage: "Audience age",
    subfields: ["audienceAgeFrom", "audienceAgeTo", "audienceAgeDensity"],
    dash: true,
  },
  {
    name: FILTER_FIELD_NAMES.SELECTED_AUDIENCE_COUNTRIES,
    id: "front_audience_country",
    defaultMessage: "Audience country",
    field: "label",
    secondField: "percent",
  },
  {
    name: FILTER_FIELD_NAMES.SELECTED_AUDIENCE_LANGUAGES,
    id: "front_audience_language",
    defaultMessage: "Audience language",
    field: "label",
    secondField: "percent",
  },
  {
    name: FILTER_FIELD_NAMES.AUDIENCE_GENDER,
    id: "front_audience_gender",
    defaultMessage: "Audience gender",
    subfields: ["audienceGender", "audienceGenderDensity"],
  },
  {
    name: FILTER_FIELD_NAMES.CHOSEN_BRANDS,
    id: "front_audience_brand_affinity",
    defaultMessage: "Audience brand affinity",
  },
  {
    name: FILTER_FIELD_NAMES.CHOSEN_TOPICS,
    id: "front_audience_interests",
    defaultMessage: "Audience interests",
  },
  {
    name: FILTER_FIELD_NAMES.CHOSEN_INFLUENCER_IG_CATEGORIES,
    id: "front_influencer_ig_categories",
    defaultMessage: "Influencer categories",
  },
  {
    name: FILTER_FIELD_NAMES.CHOSEN_INFLUENCER_SNAPCHAT_CATEGORIES,
    id: "front_influencer_snapchat_categories",
    defaultMessage: "Influencer categories",
  },
  {
    name: FILTER_FIELD_NAMES.CHOSEN_INFLUENCER_INTERESTS,
    id: "front_influencer_interests",
    defaultMessage: "Influencer interests",
  },
  {
    name: FILTER_FIELD_NAMES.INFLUENCER_AGE,
    id: "front_influencer_age",
    defaultMessage: "Influencer age",
    subfields: ["influencerAgeFrom", "influencerAgeTo"],
    dash: true,
  },
  {
    name: FILTER_FIELD_NAMES.SELECTED_INFLUENCER_COUNTRIES,
    id: "front_influencer_country",
    defaultMessage: "Influencer country",
    field: "label",
  },
  {
    name: FILTER_FIELD_NAMES.SELECTED_INFLUENCER_CITIES,
    id: "front_influencer_city",
    defaultMessage: "Influencer city",
    field: "label",
  },
  {
    name: FILTER_FIELD_NAMES.INFLUENCER_FOLLOWERS,
    id: "front_followers_count",
    defaultMessage: "Followers count",
  },
  {
    name: FILTER_FIELD_NAMES.SELECTED_PROVIDERS,
    id: "front_influencer_social_platform",
    defaultMessage: "Social platform",
    field: "label",
  },
  {
    name: FILTER_FIELD_NAMES.INFLUENCER_SOCIAL_USERNAME,
    id: "front_influencer_social_username",
    defaultMessage: "Username",
    field: "label",
  },
  {
    name: FILTER_FIELD_NAMES.INFLUENCER_GENDER,
    id: "front_influencer_gender",
    defaultMessage: "Influencer gender",
    field: "label",
  },
  {
    name: FILTER_FIELD_NAMES.AUDIENCE_CREDIBILITY_SCORE,
    id: "front_profile_data_credibility",
    defaultMessage: "Credibility",
    field: "label",
  },
  {
    name: FILTER_FIELD_NAMES.PAID_POST_PERFORMANCE_MIN,
    id: "front_profile_data_paid_post_performance",
    defaultMessage: "Paid post performance",
    field: "label",
  },
  {
    name: FILTER_FIELD_NAMES.MINIMUM_ER,
    id: "front_minimum_er",
    defaultMessage: "Minimum ER",
    field: "label",
  },
  {
    name: FILTER_FIELD_NAMES.CHOSEN_KEYWORDS,
    id: "front_keyword",
    defaultMessage: "Keyword",
  },
  {
    name: FILTER_FIELD_NAMES.LAST_POSTS_WITHIN,
    id: "front_last_posts_within",
    defaultMessage: "Last posts within",
    field: "label",
  },
  {
    name: FILTER_FIELD_NAMES.SEARCH_CONTENTS,
    id: "front_content_keyword",
    defaultMessage: "Content keyword",
  },
  {
    name: FILTER_FIELD_NAMES.SEARCH_HASHTAGS,
    id: "front_hashtag",
    defaultMessage: "Hashtag",
    option: "hashtagsOption",
  },
  {
    name: FILTER_FIELD_NAMES.SEARCH_MENTIONS,
    id: "front_mention",
    defaultMessage: "Mention",
    option: "mentionsOption",
  },
  {
    name: FILTER_FIELD_NAMES.SEARCH_BIO_KEYWORDS,
    id: "front_search_in_bio",
    defaultMessage: "Search in Bio",
  },
  {
    name: FILTER_FIELD_NAMES.HAS_CONTACT_DATA,
    id: "front_show_only_results_with_contact_data",
    defaultMessage: "Show only results with contact data",
    field: "label",
  },
  {
    name: FILTER_FIELD_NAMES.EXCLUDE_CREATORS_FROM_LIST,
    id: "front_exclude_creators_already_added_to_the_list",
    defaultMessage: "Exclude creators already added to the list",
    field: "label",
  },
  {
    name: FILTER_FIELD_NAMES.SHOW_ONLY_CREATORS_AVAILABLE_IN_CRM,
    id: "front_show_only_creators_available_in_crm",
    defaultMessage: "Show only creators available in CRM",
    field: "label",
  },
  {
    name: FILTER_FIELD_NAMES.CREATORS_AVAILABLE_IN_CRM,
    field: "label",
  },
  {
    name: FILTER_FIELD_NAMES.CHOSEN_UNIFIED_CATEGORIES,
    id: "front_unified_categories",
    defaultMessage: "Influencer categories",
  },
  {
    name: FILTER_FIELD_NAMES.CREATOR_TAGS,
    id: "front_excluded_creator_tag",
    defaultMessage: "Excluded creator tag",
    field: "label",
  },
];

export const addFilter = (type, tagProps, targetFilters, sourceFilters) => {
  const newFilters = { ...targetFilters };
  const { name, subfields, idx } = tagProps;

  const addValueToFilter = (filterName, sourceKey) => {
    const value = sourceFilters[sourceKey]?.[idx];
    const target = newFilters[filterName] ?? [];
    if (Array.isArray(target) && value && !target.includes(value)) {
      target.push(value);
      newFilters[filterName] = target;
    }
  };

  if (name === FILTER_FIELD_NAMES.SEARCH_CONTENTS) {
    CONTENT_KEYWORD_BLACKLIST.forEach((keyword) => {
      addValueToFilter(name, keyword);
    });
  }

  if (type === FILTER_TYPES.ARRAY) {
    addValueToFilter(name, name);
  } else if (type === FILTER_TYPES.MANY_FIELDS) {
    Array.from({
      length: subfields.length,
    }).forEach((_, i) => {
      const label = subfields[i];
      const value = sourceFilters[subfields[i]];
      if (label) {
        newFilters[label] = value;
      }
    });
  } else {
    newFilters[name] = sourceFilters[name];
  }

  return newFilters;
};

export const removeFilter = (type, tagProps, filters) => {
  const newFilters = { ...filters };
  const { name, subfields, idx } = tagProps;

  if (name === FILTER_FIELD_NAMES.SEARCH_CONTENTS) {
    CONTENT_KEYWORD_BLACKLIST.forEach((keyword) => {
      const array =
        newFilters[keyword]?.filter((i) => i !== filters[keyword][idx]) ?? [];
      newFilters[keyword] = array;
    });
  }

  if (type === FILTER_TYPES.SOCIAL_USERNAME) {
    const { username } = tagProps;
    newFilters[name] = (newFilters[name] || []).filter((u) => u !== username);
  } else if (type === FILTER_TYPES.ARRAY) {
    const array = newFilters[name]?.filter((i) => i !== filters[name][idx]);
    newFilters[name] = array;
  } else if (type === FILTER_TYPES.MANY_FIELDS) {
    newFilters[subfields[0]] = null;
    newFilters[subfields[1]] = null;

    if (newFilters[subfields[2]]) {
      newFilters[subfields[2]] = null;
    }
  } else {
    newFilters[name] = null;
  }

  return newFilters;
};
